import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'hi',
    fullName: 'Hindi',
    nativeName: 'हिन्दी',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "कुछ अद्भुत आ रहा है",
    landing_subtitle: "ArgVoid एक ऐप और गेम डेवलपमेंट स्टूडियो है। बने रहें, नई चीज़ें जल्द ही आ रही हैं!",
    select_language: "भाषा चुने",
    search_placeholder: "भाषाएँ खोजें...",
    terms_title: "सेवा की शर्तें",
    policy_title: "गोपनीयता नीति",
    cookies_title: "कूकी नीति",
    terms_content: `
        <strong>1. शर्तों की स्वीकृति</strong><br>
        ArgVoid तक पहुंच कर, सेवा की ये शर्तें स्वीकार की जाती हैं। यदि ये शर्तें सहमत नहीं हैं, तो सेवा का उपयोग नहीं किया जाना चाहिए।<br><br>

        <strong>2. प्लेटफ़ॉर्म उपयोग</strong><br>
        ArgVoid और इसके एप्लिकेशन सूचनात्मक और रचनात्मक उद्देश्यों के लिए "जैसा है" प्रदान किए जाते हैं। सेवा का उपयोग केवल वैध उद्देश्यों के लिए किया जाना चाहिए।<br><br>

        <strong>3. निषिद्ध आचरण</strong><br>
        साइट की कमजोरियों का फायदा उठाना, स्पैमिंग करना या बुनियादी ढांचे तक अनधिकृत पहुंच का प्रयास करना सख्त वर्जित है।<br><br>

        <strong>4. अस्वीकरण</strong><br>
        प्लेटफ़ॉर्म और सेवाओं को बिना किसी सूचना के किसी भी समय संशोधित किया जा सकता है। सेवा के अपटाइम या उपलब्धता के संबंध में कोई वारंटी प्रदान नहीं की जाती है।
    `,
    policy_content: `
        <strong>1. सूचना संग्रह</strong><br>
        प्लेटफ़ॉर्म को इस समय उपयोगकर्ता प्रमाणीकरण या खाता निर्माण की आवश्यकता नहीं है। आगंतुकों से कोई भी व्यक्तिगत पहचान संबंधी जानकारी (जैसे नाम या ईमेल पता) सक्रिय रूप से एकत्र नहीं की जाती है।<br><br>

        <strong>2. उपयोग डेटा</strong><br>
        साइट ट्रैफ़िक को समझने और एप्लिकेशन को बेहतर बनाने के लिए बुनियादी, अज्ञात विश्लेषण एकत्र किया जा सकता है। यह डेटा व्यक्तिगत उपयोगकर्ता पहचान से जुड़ा नहीं है।<br><br>

        <strong>3. तृतीय-पक्ष सेवाएँ</strong><br>
        होस्टिंग और एनालिटिक्स सेवाओं के लिए तृतीय-पक्ष प्रदाताओं का उपयोग किया जा सकता है। इन संबंधित प्रदाताओं की गोपनीयता प्रथाएं उनके बुनियादी ढांचे पर संसाधित अज्ञात डेटा को नियंत्रित करती हैं।<br><br>

        <strong>4. डेटा सुरक्षा</strong><br>
        प्लेटफ़ॉर्म की सुरक्षा के लिए उचित सुरक्षा उपाय लागू किए गए हैं। हालाँकि, इंटरनेट पर प्रसारण का कोई भी तरीका पूरी तरह से सुरक्षित नहीं है।<br><br>
    `,
    cookies_content: `
        <strong>1. कुकीज़ और स्थानीय संग्रहण क्या हैं?</strong><br>
        कुकीज़ और ब्राउज़र स्थानीय स्टोरेज छोटी डेटा फ़ाइलें हैं जो विज़िट के दौरान कॉन्फ़िगरेशन प्राथमिकताओं को याद रखने के लिए डिवाइस पर संग्रहीत होती हैं।<br><br>

        <strong>2. उपयोग उद्देश्य</strong><br>
        ब्राउज़र लोकलस्टोरेज का उपयोग कॉन्फ़िगरेशन सेटिंग्स को सहेजने के लिए सख्ती से किया जाता है, जैसे:<br>
        - भाषा प्राथमिकताएँ<br>
        - उपयोगकर्ता इंटरफ़ेस कॉन्फ़िगरेशन (उदाहरण के लिए, लेआउट या थीम सेटिंग्स)<br>
        - अस्थायी एप्लिकेशन कैश<br><br>

        <strong>3. कोई ट्रैकिंग नहीं</strong><br>
        कुकीज़ और स्थानीय भंडारण का उपयोग विज्ञापन या तृतीय-पक्ष ट्रैकिंग उद्देश्यों के लिए नहीं किया जाता है। सभी संग्रहीत डेटा पूरी तरह से प्लेटफ़ॉर्म.<br><br> की मुख्य कार्यक्षमता के लिए है

        <strong>4. कंट्रोल</strong><br>
        ब्राउज़र सेटिंग्स के माध्यम से ब्राउज़र डेटा को किसी भी समय साफ़ किया जा सकता है, जो किसी भी स्थानीय कॉन्फ़िगरेशन को रीसेट कर देगा।
    `,
    cookie_consent_text: "यह सुनिश्चित करने के लिए कि वेबसाइट सही ढंग से काम करे, हम बुनियादी कुकीज़ का उपयोग करते हैं, जैसे कि आपके सत्र को सक्रिय रखना, आपकी भाषा प्राथमिकता को सहेजना और अन्य कस्टम कॉन्फ़िगरेशन।",
    read_policy: "कुकी नीति पढ़ें",
    support_title: "समर्थन से संपर्क करें",
    support_subject_label: "विषय",
    support_message_label: "संदेश",
    support_submit_button: "मेसेज भेजें",
    support_hint: "नोट: इससे संदेश भेजने के लिए आपका डिफ़ॉल्ट ईमेल एप्लिकेशन खुल जाएगा।",
    support_success_msg: "आपका ईमेल ऐप खोला जा रहा है...",
    support_error_msg: "संदेश भेजने में विफल. कृपया बाद में पुन: प्रयास करें।",
    explorer_title: "एक्सप्लोरर",
    history_title: "इतिहास",
    animation_title: "एनिमेशन",
    config_title: "विन्यास",
    tool_mouse: "चुनें (Ctrl+M)",
    tool_brush: "ब्रश (Ctrl+B)",
    tool_brush_mode: "टॉगल मोड (ठोस/साफ़)",
    tool_eraser: "इरेज़र (Ctrl+E)",
    tool_brush_size: "ब्रश का आकार समायोजित करें",
    tool_bucket: "भरें (Ctrl+F)",
    tool_eyedropper: "आँख में डालने वाला",
    tool_grid: "ग्रिड (Ctrl+Shift+B)",
    tool_rotate: "घुमाएँ (Ctrl+Shift+R)",
    tool_flip_h: "फ्लिप एच (Ctrl+Shift+H)",
    tool_flip_v: "फ्लिप वी (Ctrl+Shift+V)",
    tool_transpose: "स्थानांतरण (Ctrl+Shift+T)",
    label_width: "चौड़ाई",
    label_height: "ऊंचाई",
    label_frames: "फ़्रेम की संख्या",
    label_animation: "एनीमेशन शैली",
    label_background_color: "पृष्ठभूमि का रंग",
    label_interval: "अंतराल",
    tool_anim_config: "एनिमेशन कॉन्फ़िगरेशन",
    label_new_width: "नई चौड़ाई",
    label_new_height: "नई ऊंचाई",
    label_apply: "आवेदन करना",
    label_colors: "रंग",
    label_size: "आकार",
    label_tolerance: "सहनशीलता",
    val_horizontal: "क्षैतिज",
    val_vertical: "खड़ा",
    val_sequence: "अनुक्रम",
    val_bounce: "उछलना",
    val_random: "यादृच्छिक",
    val_solid: "ठोस",
    val_clear: "स्पष्ट",
    action_add_sheet: "नई शीट",
    action_import: "आयात",
    action_export: "निर्यात",
    action_sort_projects: "क्रम से लगाना",
    sort_date_old: "सबसे पुराना पहले",
    sort_date_new: "नवीनतम प्रथम",
    sort_name_az: "नाम (ए-जेड)",
    sort_name_za: "नाम (जेड-ए)",
    action_new_sprite: "नया स्प्राइट",
    action_new_project: "नया प्रोजेक्ट",
    modal_save_all_title: "सभी परिवर्तनों को सहेजें",
    modal_save_all_desc: "सहेजने के लिए संपत्तियों का चयन करें:",
    modal_save_selected: "चयनित सहेजें",
    action_saved: "सहेजा गया",
    modal_create_sprite_title: "नया स्प्राइट बनाएं",
    modal_create_project_title: "नया प्रोजेक्ट बनाएं",
    modal_add_sheet_title: "नई शीट जोड़ें",
    modal_rename_sheet_title: "शीट का नाम बदलें",
    modal_rename_sprite_title: "स्प्राइट का नाम बदलें",
    modal_delete_sprite_title: "स्प्राइट हटाएँ",
    modal_delete_project_title: "प्रोजेक्ट हटाएँ",
    modal_delete_sheet_title: "शीट हटाएँ",
    placeholder_sprite_name: "नाम",
    placeholder_project_name: "नाम",
    placeholder_sheet_name: "नाम",
    placeholder_new_name: "नया नाम",
    action_create: "बनाएं",
    action_add: "जोड़ना",
    action_rename: "नाम बदलें",
    action_duplicate: "डुप्लिकेट",
    action_delete: "मिटाना",
    action_cancel: "रद्द करना",
    confirm_delete_sprite: "क्या आप वाकई इस स्प्राइट को हटाना चाहते हैं?",
    confirm_delete_project: "क्या आप वाकई इस प्रोजेक्ट को हटाना चाहते हैं? सभी स्प्राइट हटा दिए जाएंगे.",
    confirm_delete_sheet: "क्या आप वाकई इस शीट को हटाना चाहते हैं?",
    err_select_sprite: "कृपया पहले एक स्प्राइट चुनें.",
    err_select_project: "कृपया पहले एक प्रोजेक्ट चुनें.",
    err_name_empty: "नाम खाली नहीं हो सकता.",
    err_sprite_exists: "इस नाम का एक स्प्राइट पहले से मौजूद है।",
    err_project_exists: "इस नाम का एक प्रोजेक्ट पहले से मौजूद है.",
    err_no_content: "सहेजने के लिए कोई सामग्री नहीं.",
    err_no_changes: "सहेजने के लिए कोई परिवर्तन नहीं.",
    err_delete_last_sheet: "अंतिम शीट को हटाया नहीं जा सकता.",
    err_extract_frames: "कोई फ़्रेम नहीं निकाला जा सका.",
    err_indexeddb: "स्थानीय स्तर पर सहेजने में विफल. हो सकता है कि आपका ब्राउज़र IndexedDB का समर्थन न करे.",
    msg_upload_success: "अपलोड सफल: {0}",
    msg_upload_failed: "अपलोड विफल: {0}",
    msg_save_success: "सफल सहेजें.",
    msg_saving: "सहेजा जा रहा है...",
    msg_multi_save_result: "{0} परिसंपत्तियाँ सहेजी गईं। {1} विफलताएँ।",
    menu_title: "मेनू",
    menu_save: "बचाना",
    menu_save_all: "सब को सुरक्षित करें",
    menu_support: "समर्थन से संपर्क करें",
    label_local_storage: "स्थानीय भंडारण",
    label_sign_in: "दाखिल करना",
    modal_export_title: "स्प्राइट निर्यात करें",
    label_filename: "फ़ाइलनाम",
    label_format: "प्रारूप",
    action_export_confirm: "निर्यात",
};

export default translations;
